import { scopeFor, ScopeNotReadyError } from "@/queries/scope";

/**
 * The scope to cache `slug`'s reads and writes under, or `null` while the
 * session has not said who is signed in yet, so there is no key to cache
 * under. `owner` names the writer or loader in the warning.
 */
export function queryCacheScope(slug: string, owner: string) {
  try {
    return scopeFor(slug);
  } catch (error) {
    if (!(error instanceof ScopeNotReadyError)) throw error;
    console.warn(`[${owner}] used before the session resolved; not cached`, { slug });
    return null;
  }
}
